import { render, staticRenderFns } from "./AppButtonEditCancelTreament.vue?vue&type=template&id=30b2da26&scoped=true&"
import script from "./AppButtonEditCancelTreament.vue?vue&type=script&lang=ts&"
export * from "./AppButtonEditCancelTreament.vue?vue&type=script&lang=ts&"
import style0 from "./AppButtonEditCancelTreament.vue?vue&type=style&index=0&id=30b2da26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2da26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
